import { useState } from "react";
import ConfirmModal from "../components/modals/ConfirmModal";

const useConfirmModal = () => {
  const [modalState, setModalState] = useState(null);

  const confirm = (options) =>
    new Promise((resolve) => {
      setModalState({
        ...options,
        resolve
      });
    });

  const handleConfirm = () => {
    modalState.resolve(true);
    setModalState(null);
  };

  const handleCancel = () => {
    modalState.resolve(false);
    setModalState(null);
  };

  const ConfirmModalRenderer = () =>
    modalState ? (
      <ConfirmModal
        isOpen
        title={modalState.title}
        message={modalState.message}
        confirmText={modalState.confirmText}
        cancelText={modalState.cancelText}
        confirmClass={modalState.confirmClass}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    ) : null;

  return { confirm, ConfirmModalRenderer };
};

export default useConfirmModal;
